export function computeLetterbox(actualW, actualH, stageW, stageH) {
  const imageAspect = actualW / actualH;
  const stageAspect = stageW / stageH;
  let imgW, imgH;
  if (imageAspect > stageAspect) {
    imgW = stageW;
    imgH = stageW / imageAspect;
  } else {
    imgH = stageH;
    imgW = stageH * imageAspect;
  }
  return {
    imgX: (stageW - imgW) / 2,
    imgY: (stageH - imgH) / 2,
    imgW,
    imgH,
  };
}

export function insideImage(pos, imgX, imgY, imgW, imgH) {
  return pos.x >= imgX && pos.x <= imgX + imgW && pos.y >= imgY && pos.y <= imgY + imgH;
}

export function angleToClockHour(deg) {
  const normalized = ((deg % 360) + 360) % 360;
  const hour = Math.round(normalized / 30) % 12;
  return hour === 0 ? 12 : hour;
}

export function toImagePixels(dot, imgX, imgY, imgW, imgH, actualW, actualH) {
  return [
    {
      x: ((dot.x - imgX) / imgW) * actualW,
      y: ((dot.y - imgY) / imgH) * actualH,
    },
  ];
}
